export const CONFIG = {
  // REDIS
  UPSTASH_REDIS_REST_URL: process.env.UPSTASH_REDIS_REST_URL,
  UPSTASH_REDIS_REST_TOKEN: process.env.UPSTASH_REDIS_REST_TOKEN,

  // ZOHO
  ZOHO_CLIENT_ID: process.env.ZOHO_CLIENT_ID,
  ZOHO_CLIENT_SECRET: process.env.ZOHO_CLIENT_SECRET,
  ZOHO_REFRESH_TOKEN: process.env.ZOHO_REFRESH_TOKEN,
  ZOHO_REDIRECT_URI: process.env.ZOHO_REDIRECT_URI,

  // CRON JOB
  CRON_SECRET: process.env.CRON_SECRET,

  // GOOGLE
  GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY,
  GOOGLE_ANALYTICS_ID: process.env.GOOGLE_ANALYTICS_ID,

  // GENERAL DETAILS
  facebookUsername: "profile.php?id=100064906843760",
  instagramUsername: "sphogmoss",
  tiktokUsername: "sphogmoss",
  youtubeUsername: "sphog-moss",
  whatsappNumber: "972542267889",
  phoneNumber: "0547256800",
  contactEmail: "sphogmoss@gmail.com",
  contactAddress: "התחייה 16, תל אביב, ישראל",
  lat: 32.0498611,
  lng: 34.7628056,
  /** Official Google Maps / reviews short link for Sphog */
  googleReviewsUrl: "https://maps.app.goo.gl/vab9eWxxaSwFav9s6",
  year: 2025,
};
